<dealer-display></dealer-display>
<div class="id-failure">
	<div class="id-failure__content">
		<div class="id-failure__image">
			<img src="assets/img/birds/dod-bird-id-unsuccessful.png" alt="Dodo bird" />
		</div>
		<div class="id-failure__info">
			<h2 class="id-failure__title">Identity verification unsuccessful</h2>
			<p class="id-failure__text">
				Thanks for submitting your ID. Unfortunately, we weren't able to successfully complete the identity checks using the information provided.
			</p>
		</div>
	</div>
	<div class="id-failure__actions">
		<button class="id-failure__btn" (click)="gotoMainSite()">BACK TO DODO.COM</button>
	</div>
</div>
